export default __webpack_public_path__ + "static/media/01_Kom_Leoland.0381f0de.jpg";